import React from "react";
import styled from "styled-components";
import GamesFooter from "./GamesFooter";
import SelectGameSection from "./SelectGameSection";
import { CardBody } from "best-common-react";
import { useGames } from "../../contexts/GamesContext";
import useCardSettings from "../../customhooks/useCardSettings";
import SectionHolder from "./lineup/SectionHolder";
import LineupHeader from "./lineup/LineupHeader";

const Container = styled.div.attrs(() => ({
  className: "d-flex",
}))``;

const FormHolder = styled.div.attrs(() => ({
  className: "mt-1",
}))`
  width: 100%;
`;

const SectionDivider = styled.hr.attrs(() => ({
  className: "mb-3 mt-3 mr-3 ml-3",
}))`
  height: 1px;
  width: 100%;
  color: #dee5ed;
`;

const Games = () => {
  const {
    state: { selectedGames },
  } = useGames();
  const { cardSettings } = useCardSettings();

  return (
    <Container>
      <FormHolder>
        <CardBody>
          <SelectGameSection cardSettings={cardSettings} />
        </CardBody>
        <SectionDivider />
        <div className="row">
          <div className="col">
            {selectedGames.length === 1 ? (
              <div>
                <LineupHeader />
                <SectionHolder />
              </div>
            ) : (
              "Please select only one game to set lineup"
            )}
          </div>
        </div>
        <GamesFooter cardSettings={cardSettings} />
      </FormHolder>
    </Container>
  );
};

export default Games;
